<template>
  <div>
    <h1>Catalogue des Cartes (Boucle interne)</h1>
    <b-row>
      <b-col md="3">
        <b-form-group horizontal class="mb-0">
          <b-input-group>
            <b-form-input v-model="filter" placeholder="Rechercher" />
            <b-input-group-append>
              <b-btn :disabled="!filter" @click="filter = ''">Effacer</b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="2" class="my-1">
        <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage" />
      </b-col>
      <b-col>
        <b-button size="sm" class="mr-2" style="margin-left: 50%;" :disabled='clicked' @click="prepareCSV()">Mettre à jour PTouch</b-button>
      </b-col>
      <b-col md="3" class="mb-0">
        <b>Global Average: </b> {{stats.global_average}}j<br>
        <b>Number of Scans: </b>{{stats.nbr_scans}}<br>
        <b>Number of Cards: </b>{{stats.nbr_cards}}
      </b-col>
    </b-row>
    <!-- <b-form-checkbox v-model="small">Small</b-form-checkbox>
    <b-form-checkbox v-model="dark">Dark</b-form-checkbox>
    <b-form-checkbox v-model="fixed">Fixed</b-form-checkbox> -->
    <b-toast id="example-toast" title="BootstrapVue" static auto-hide-delay="1500">
      Notification pop-up
    </b-toast>
    <b-table  hover
              :bordered="bordered"
              :busy.sync="isBusy"
              :outlined="outlined"
              :small="small"
              :dark="dark"
              :fixed="fixed"
              :foot-clone="footClone"
              :items="items"
              :filter="filter"
              :fields="fields"
              filter-debounce="300"
              @filtered="onFiltered"
              :current-page="currentPage"
              :per-page="perPage">
      <div slot="table-busy" class="text-center text-danger my-2">
        <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
        <span class="sr-only">Loading...</span>
      </div>
      <!-- <template v-slot:cell(min_max)="row">
         {{ Math.round(row.item.min / (3600*24)) }}j / {{ Math.round(row.item.max / (3600*24))}}j
      </template> -->
      <template v-slot:cell(admin)="row">
        <div>
          <b-form>
            <b-form-input
              type="text"
              v-model="form[row.item.card_id]"
              placeholder="Entrez l'ID kanban"
              aria-describedby="exampleInput1Feedback"
              v-uppercase/>
            <b-button @click="updateReference(row.item)" variant="primary">Envoyer</b-button>
          </b-form>
          <p v-if="displayError"><span>{{errorMsg}}</span></p>
        </div>
      </template>
      <template v-slot:cell(remove)="row">
        <b-button size="sm" variant="danger" @click="clickRemove(row.item)" class="mr-2">
            <i class="fa fa-trash" aria-hidden="true"></i>
          </b-button>
      </template>
      <template v-slot:cell(days_since_scan)="row">
        <p> {{row.item.days_since_scan}} J
          <b-button size="sm"
            style="font-size:12px;margin-left:10px;"
            @click="goTo('/scankanban/'+row.item.last_workstation+'/'+row.item.code)"
            v-if="row.item.last_workstation"
            variant="outline-primary">
            Scans
            <!-- <i class="fa fa-barcode" aria-hidden="true"></i> -->
          </b-button>
          <b-button size="sm"
            style="font-size:12px;margin-left:10px;"
            @click="goTo('/andon_internal/'+row.item.code)"
            class="mr-2"
            variant="outline-primary">
              Hippodrome
          </b-button>
        </p>
      </template>
    </b-table>
    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination :total-rows="totalRows" :per-page="perPage" align="center" v-model="currentPage" />
      </b-col>
    </b-row>
  </div>
</template>
<script>

import server from '../../api/server.vue'
import moment from 'moment'

const items = [
  { first_name: 'Loading', last_name: 'Loading' },
]
const detailsItems = [
  { first_name: 'Loading', last_name: 'Loading' },
]

export default {
  name: 'InternalLoopKanbanList',
  data() {
    return {
        displayError: false,
        errorMsg: '',
        clicked: false,
        items: items,
        currentPage: 1,
        totalRows: 1,
        perPage: 25,
        bordered: true,
        outlined: true,
        isBusy: true,
        small: false,
        hover: false,
        dark: false,
        fixed: false,
        filter: null,
        footClone: true,
        previousRowDetailed: null,
        detailsItems: detailsItems,
        stats: {},
        totalDetailsRows: 1,
        form: {
          code: ''
        },
        fields: [
          { key: 'card_id', sortable: true, label : 'Id carte' },
          { key: 'card_index', sortable: true, label : 'N° carte' },
          { key: 'code', sortable: true, label : 'Reference' },
          { key: 'designation', sortable: true },
          { key: 'emplacement', sortable: true },
          { key: 'batch_size', sortable: true },
          { key: 'andon', sortable: true },
          { key: 'last_workstation', sortable: true },
          { key: 'average', sortable: true, label : 'Moyenne' },
          // { key: 'min_max', sortable: true },
          { key : 'days_since_scan', sortable: true, label : 'Carte précédente vue il y a' },
          // { key: 'count', sortable: true },
          { key: 'created_at', sortable: true, label : 'Crée le' },
          'admin',
          'remove'
        ],
      };
  },
  methods: {
    updateReference(row) {
      server.changeReferenceLink(row.card_id, this.form[row.card_id]).then((result) => {
        if (result.data === 'NO_EXISTING_REF') {
          this.displayError = true
          this.errorMsg = result.data
        } else {
          this.displayCards()
        }
      })
    },
    displayCards () {
      server.getAllKanbanCard('loop_usual_components').then( response =>  {
        var data = response.data.kanban_cards
        this.totalRows = data.length
        this.stats = response.data.stats
        var formatedResult = []
        var removed = true
        var rowColors = ['', 'secondary']
        var currentRowColorIndex = 0
        var currentRowColor = ''
        var currentKanbanReference = null
        var now = moment()
        for (var i = 0; i < this.totalRows; i++)
        {
          if ( currentKanbanReference != data[i]['code'])
          {
            currentRowColorIndex += 1
            currentRowColor = rowColors[currentRowColorIndex%2]
            currentKanbanReference = data[i]['code']
          }
          if (data[i]['average'])
          {
            data[i]['average'] = String(Math.round(data[i]['average'] / (3600*24))) + 'j'
          }
          // data[i]['_cellVariants'] = { isActive: 'success', removed: removed}
          data[i]['_rowVariant'] = currentRowColor
          data[i]['created_at'] = data[i]['created_at'].split(' ')[0]
          data[i]['code'] = data[i]['code']
          data[i]['emplacement'] = data[i]['zone'] + data[i]['pos_y'] + ('0' + data[i]['pos_x']).slice(-2)  + data[i]['pos_z']

          if ( _.isEmpty(data[i]['scan_at']) ) {
            data[i]['days_since_scan'] = 0
          } else {
            data[i]['days_since_scan'] = now.diff(moment(data[i]['scan_at']), 'days')
          }

          if (data[i]['andon']) {
            data[i]['_rowVariant'] = 'danger'
          }
          if (data[i]['removed']) {
            removed = 'danger'
            data[i]['removed'] = 'yes'
          } else {
            removed = ''
            data[i]['removed'] = ''
            formatedResult.push(data[i])
          }
        }
        this.items = formatedResult
        this.isBusy = false
      })
    },
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    showDetail (row) {
      server.getAllKanbanCard('loop_usual_components').then( response =>  {
        this.detailsItems = response.data
        this.totalDetailsRows = this.detailsItems.length
      })

    },
    makeToast(append = false) {
      let toast = this.$toasted.success("Excel généré ! Vous pouvez l'ouvrir dans Ptouch", {
         theme: "bubble",
         position: "top-right",
         duration : 5000
      });
    },
    prepareCSV () {
      this.clicked = true
      server.generateDataCSV('loop_usual_components').then((response) => {
        this.clicked = false
        this.makeToast()
      })
    },
    clickRemove (item) {
      var params = { 'card': item.card_id, 'token': window.localStorage.getItem('adminToken') }
      server.deteteKanbanCard(params).then( response => {
        this.displayCards()
      })
    }
  },
  mounted: function () {
    if (window.localStorage.getItem('isAdmin') !== 'ADMIN'){
      this.fields.pop()
      this.fields.pop()
    }
    this.filter = this.$route.params.filter
    this.isBusy = false
    this.displayCards()
  }
};
</script>



// WEBPACK FOOTER //
// src/components/supply/InternalLoopKanbanList.vue